export default "__VITE_ASSET__rLwn34g1VKkGjTLOsfU76g__"